// Request Schema (should passed as query params)
export interface Request {
    word: string,
    type: TranslateMethod
}
export enum TranslateMethod {
    Umschrift = "umschrift",
    Arabic = "arabisch"
}

// Response Schema
// Case "1" : Where Row Count > 1
export interface Response1 {
    results: WordTranslation[]
}

// Case "2" : Where Row Count = 1
export interface Response2 {
    arabics: Arabic[],
    deutch: Deutch,
    morphemType: Arabic,
    elativ: Arabic,
    wurzel: Arabic
}

export interface WordTranslation {
    arabic: Arabic,
    deutch: Deutch
}

export interface Arabic {
    arabicUmschrift: string,
    arabicWord: string,
    linkTypeInfo?: string,
    pronunciation: string
}

export interface Deutch {
    deutchWord?: string,
    notExist?: {
        label: string,
        arabicUmschrift: string,
        arabicWord: string,
        linkUrl: string
    }
}



export interface CreateIssueRequestInput {
    email: string;
    report: string
}
